import { createEnrichmentIsland } from "@/utils/islands";
import { openLogin } from "./login";
import {hasValidToken} from "@sitecorecomponents/Users/Store/tokenstore";
import { refreshUnreadMessageIndicator } from "./unread-indicator";

const action = async () => {

  const alreadyAuthenticated = hasValidToken();
  if (alreadyAuthenticated) {
    return;
  }

  // openLogin resolves once its modal closes, true when the user got a token.
  if (await openLogin()) {
    void refreshUnreadMessageIndicator();
  }
}

const clickHandler = (e: MouseEvent) => {
  e.preventDefault();
  action();
}

/** Authenticated: the same header button opens a popup below itself instead of
 *  the login modal. Contents come from the account-top-menu placeholder. */
function initProfileMenu() {
  // alsoForEditing: the popup is the only way to reach what sits in the
  // account-top-menu placeholder, so it has to open in the editor too.
  createEnrichmentIsland('[profile-menu-btn]', (btn: Element) => {
    const popupId = btn.getAttribute('aria-controls');
    const popup = popupId ? document.getElementById(popupId) : null;
    if (!popup) {
      return;
    }

    const setOpen = (open: boolean) => {
      btn.setAttribute('aria-expanded', String(open));
      popup.classList.toggle('hidden', !open);
    };

    btn.addEventListener('click', (e: Event) => {
      e.stopPropagation();
      setOpen(btn.getAttribute('aria-expanded') !== 'true');
    });

    document.addEventListener('click', (e: Event) => {
      if (!popup.contains(e.target as Node)) {
        setOpen(false);
      }
    });

    document.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') {
        setOpen(false);
        (btn as HTMLElement).focus();
      }
    });
  }, { editing: true });
}

export default function () {
  createEnrichmentIsland('[login-btn]', (elm: Element) => {
    elm.addEventListener('click', (event: Event) => clickHandler(event as MouseEvent));

    if (elm.getAttribute('login-btn') === 'open') {
      action();
    }
  });

  createEnrichmentIsland('li[class~=icon-user] a', (elm: Element) => {
    elm.addEventListener('click', (event: Event) => clickHandler(event as MouseEvent));
  });

  initProfileMenu();
  void refreshUnreadMessageIndicator();
}
